@if (url$ | async; as url) {
	<div class="header-container" [ngClass]="{ contrast: url !== '/anamnese', admin: config.app === ClientName.TM_ADMIN }">
		<div>
			@if (showMenuContents(url)) {
				<h1 class="title barlow-condensed">
					{{ title() }}
					@if (config.app === ClientName.TM_ADMIN) {
						<span>{{ adminDisplayName$ | async }} ({{ adminUsername$ | async }})</span>
					}
				</h1>
			}
		</div>
		<div class="right">
			@if (showMenuContents(url)) {
				<div class="main-menu">
					<div class="button-container">
					<!-- Admin menu, only visible in TM Admin -->
					@if (isAdminMenuVisible$ | async){
						<button mat-button
							[matMenuTriggerFor]="adminMenu"
							[ngClass]="{ active: url.startsWith('/admin') }"
							data-cy="admin-menu-button"
						>Admin</button>
						<mat-menu #adminMenu="matMenu">
							@for (entry of adminMenuEntries(); track entry) {
								@if ((isAdminMenuEntryVisible(entry) | async)) {
									<button mat-menu-item
										(click)="onMenuButtonClick(entry)"
									>
										{{ entry["title"] | translate }}
									</button>
								}
							}
						</mat-menu>
					}
					@if (viewportStore.isMediumOrSmallerScreen()) {
						<button mat-button [matMenuTriggerFor]="mobileMenu">
							<fa-icon [icon]="faBars"></fa-icon>
						</button>
						<mat-menu #mobileMenu="matMenu">
							<ng-container
								[ngTemplateOutlet]="menuEntriesTpl"
								[ngTemplateOutletContext]="{ url: url, isMenuItem: true, menuEntries: menuEntries() }">
							</ng-container>
						</mat-menu>
					}@else{
						<ng-container
							[ngTemplateOutlet]="menuEntriesTpl"
							[ngTemplateOutletContext]="{ url: url, isMenuItem: false, menuEntries: menuEntries() }">
						</ng-container>
					}
					@if (subMenuEntries().length) {
						<button mat-button [matMenuTriggerFor]="submenu">
							<fa-icon [icon]="faCog"></fa-icon>
						</button>
						<mat-menu #submenu="matMenu">
							<ng-container
								[ngTemplateOutlet]="menuEntriesTpl"
								[ngTemplateOutletContext]="{ url: url, isMenuItem: true, menuEntries: subMenuEntries() }">
							</ng-container>
							@if (isEtrackerInitialized()) {
								<a mat-menu-item href="javascript:et_showOptIn()">
									{{"Cookie Settings" | translate}}
								</a>
							}
						</mat-menu>
					}
					<button mat-button (click)="signout()" [matTooltip]="'Signout' | translate" data-cy="signout-button">
						<fa-icon [icon]="faSignOut"></fa-icon>
					</button>
					</div>
					<div class="hotline-maintenance-container">
						@if (config.app === ClientName.TM) {
							<div class="hotline">
								<fa-icon [icon]="faPhone"></fa-icon>+49 2104 80041-00
							</div>
						}
						@if (timeToMaintenance$ | async; as timeToMaintenance) {
							@if (timeToMaintenance) {
								<div class="maintenance">
									<fa-icon [icon]="faUserHelmetSafety"></fa-icon>
									<span>{{ "Maintenance in:" | translate }}</span> {{ timeToMaintenance }}
								</div>
							}
						}
					</div>
				</div>
			}
			<button mat-button [matMenuTriggerFor]="langMenu" data-cy="lang-menu-button">
				<fa-icon [icon]="faGlobe"></fa-icon> {{translate.getCurrentLang() | uppercase}}
			</button>
			<mat-menu #langMenu="matMenu">
						<button
							mat-menu-item
							(click)="switchLanguage('de')"
							data-cy="lang-menu-item-de"
						>
							{{ "German" | translate }}
						</button>
						<button
							mat-menu-item
							(click)="switchLanguage('en')"
							data-cy="lang-menu-item-en"
						>
							{{ "English" | translate }}
						</button>
			</mat-menu>
			<img src="assets/img/logo_scheu.svg" />
		</div>
	</div>
}

<ngx-loading-bar [height]="'5px'" [color]="'#be0e11'" [includeSpinner]="false" />

<ng-template #menuEntriesTpl let-url="url" let-isMenuItem="isMenuItem" let-menuEntries="menuEntries">
	@for (entry of menuEntries; track entry) {
		@if (isMenuItem) {
			<button
				mat-menu-item
				(click)="onMenuButtonClick(entry)"
			>
				{{ entry["title"] | translate }}
			</button>
		} @else {
			<button
				mat-button
				(click)="onMenuButtonClick(entry)"
				[ngClass]="{ active: url.startsWith(entry['route']) }"
			>
				{{ entry["title"] | translate }}
			</button>
		}
	}
</ng-template>
